/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Error_Vehicle_MismatchInputs */

const vi_trip_error_vehicle_mismatch = /** @type {(inputs: Trip_Error_Vehicle_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe không khớp chuyến hiện tại`)
};

/**

* @param {Trip_Error_Vehicle_MismatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_error_vehicle_mismatch = /** @type {((inputs?: Trip_Error_Vehicle_MismatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Error_Vehicle_MismatchInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_error_vehicle_mismatch(inputs)
});